import { render, staticRenderFns } from "./trackingInfo.vue?vue&type=template&id=54651f8e&scoped=true&"
import script from "./trackingInfo.vue?vue&type=script&lang=js&"
export * from "./trackingInfo.vue?vue&type=script&lang=js&"
import style0 from "./trackingInfo.vue?vue&type=style&index=0&id=54651f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54651f8e",
  null
  
)

export default component.exports